/**
 * The query parameters a social auth redirect appends on its way back.
 *
 * A leaf module, and it has to stay one: the gate state modules read these
 * names at module scope, so whatever this file imports runs at import time
 * too. Reaching them through `use-auth-event` pulls in the user module, the
 * tracker and aria behind them, which closes a cycle. Keep this file free of
 * imports.
 */
export const AUTH_TYPE_PARAM_KEY = 'auth-type';
export const AUTH_SOURCE_PARAM_KEY = 'auth-source';
export const AUTH_PROVIDER_PARAM_KEY = 'provider';
